<button [id]="componentId + '-btn'" [attr.data-cy]="componentId + '-btn'" (click)="emitClick($event)"
  class="text-white bg-blue-200 w-full rounded px-9 py-2 hover:bg-blue-300 text-sm">
  {{btnText}} <ng-content></ng-content>
</button>
